import { render, staticRenderFns } from "./DocumentChooserCreateDialog.vue?vue&type=template&id=2d85b1fc&"
import script from "./DocumentChooserCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./DocumentChooserCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentChooserCreateDialog.vue?vue&type=style&index=0&id=2d85b1fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports